module.exports = __webpack_public_path__ + "static/media/nsa2.d5f4726b.jpg";